var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFiRrCustomer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.181,
    height: 21.574,
    viewBox: "0 0 16.181 21.574",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3855",
    "data-name": "Group 3855",
    transform: "translate(-48 -637.469)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fi-rr-user",
    transform: "translate(48 637.469)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5266",
    "data-name": "Path 5266",
    d: "M11.394,10.787A5.394,5.394,0,1,0,6,5.394a5.394,5.394,0,0,0,5.394,5.394Zm0-8.989a3.6,3.6,0,1,1-3.6,3.6,3.6,3.6,0,0,1,3.6-3.6Z",
    transform: "translate(-3.303)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5267",
    "data-name": "Path 5267",
    d: "M11.09,14A8.1,8.1,0,0,0,3,22.09a.9.9,0,1,0,1.8,0,6.292,6.292,0,0,1,12.585,0,.9.9,0,0,0,1.8,0A8.1,8.1,0,0,0,11.09,14Z",
    transform: "translate(-3 -1.415)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRrCustomer);
export default __webpack_public_path__ + "static/media/fi-rr-customer.d8750f47.svg";
export { ForwardRef as ReactComponent };